import React, { Fragment } from 'react'
import { Grid } from 'semantic-ui-react'
import Tags from '../Resources/Tags'
import InternalExpertTags from '../Experts/ExpertTags'

const ExpertTags = ({ expert }) => {
    return (
        <Grid.Row>
            <Grid.Column>
                <Grid.Row>Expert tags: </Grid.Row>
                <Grid.Row>
                    <Tags
                        tags={expert.expert.functions.concat(
                            expert.expert.organization.type,
                            expert.expert.medical_specialties,
                            expert.expert.technology_tags
                        )}
                        internal_tags={[]}
                    />
                </Grid.Row>
                <Fragment>
                    <Grid.Row>Analyst tags: </Grid.Row>
                    <Grid.Row>
                        <InternalExpertTags
                            expert={expert}
                            showInternalOnly={true}
                        />
                    </Grid.Row>
                </Fragment>
            </Grid.Column>
        </Grid.Row>
    )
}

export default ExpertTags
